import { PROJECT_MALL_NEW_FILE_NAME } from '@/features/project-mall/runtime'

export const PROJECT_CURRENT_DIR = 'current'
export const PROJECT_LIST_INDEX = 'projectIndex.json'
export const PROJECT_CURRENT_DATA_DIR = `${PROJECT_CURRENT_DIR}/Data`
export const PROJECT_CURRENT_PROJECT_BIN = `${PROJECT_CURRENT_DIR}/projectS.bin`
export const PROJECT_CURRENT_RES_JSON = `${PROJECT_CURRENT_DIR}/res.json`
export const PROJECT_CURRENT_INFO = `${PROJECT_CURRENT_DIR}/projectInfo.txt`
export const PROJECT_CURRENT_PASSTHROUGH_MAP = `${PROJECT_CURRENT_DIR}/passthroughMap.json`
export const PROJECT_CURRENT_TAG_DRAFT = `${PROJECT_CURRENT_DIR}/NewORG.tag`
export const PROJECT_CURRENT_PAY_TYPE = `${PROJECT_CURRENT_DIR}/ORG.pay`
export const PROJECT_CURRENT_MALL_NEW = `${PROJECT_CURRENT_DATA_DIR}/${PROJECT_MALL_NEW_FILE_NAME}`
